import { Component, input, output } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { MatIconButton } from "@angular/material/button";
import { TranslocoPipe } from "@jsverse/transloco";
import { SharedUiIconButtonModule } from "shared/ui/icon-button";

@Component({
    selector: "pcp-slide-sync-fullscreen-button",
    template: `
        <button
            class="icon-button"
            (click)="toggleFullscreen.emit()"
            pcp-ui-icon-button
            size="medium"
            mat-icon-button
            id="fullscreen"
            [title]="'button.fullscreen' | transloco"
            [style.transform]="'scale(' + scale() + ')'"

        >
            <mat-icon [fontIcon]="isFullscreen() ? 'close_fullscreen' : 'open_in_full'" />
        </button>
    `,
    styles: [`
        button {
            background-color: white;
            width: unset !important;
        }

        button:hover mat-icon {
            /* NOTE: same as --slide-sync-favorite-button-color-hovered */
            color: #86bc24;
        }
    `],
    imports: [
        MatIcon,
        MatIconButton,
        SharedUiIconButtonModule,
        TranslocoPipe,
    ],
})
export class FullscreenButtonComponent {
    scale = input<number>(1);
    isFullscreen = input<boolean>(false);

    toggleFullscreen = output<void>();
}
